import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'core-layout-modal-feedback',
    templateUrl: './modal-feedback.component.html',
    styleUrls: ['./modal-feedback.component.scss']
})
export class LayoutModalFeedbackComponent {
    /**
     * @type: possible icons on the modal:
     * success: rockect launched
     * done: tick green in a circle
     * fail: red cross in a circle
     * warning: yellow exclamation mark in a circle
     * warning-alert: warning yellow triangle
     */
    @Input() type: string;
    @Input() text: string;
    @Input() message: string;
    @Input() buttonText: string;
    @Input() secondButtonText: string = "";
    @Input() disabled: boolean = false;

    @Output() action = new EventEmitter<boolean>();
    @Output() secondButtonAction = new EventEmitter<boolean>();

    onAction() {
        this.action.emit(true);
    }

    onSecondAction() {
        this.secondButtonAction.emit(true);
    }
}
